import { FileAPI } from '../api'

const getFileUrl = (file) => {
  if (file && /^http/.test(file)) return file
  return FileAPI.getUrl(file)
}

export default getFileUrl
